import * as Log from "web-ui/log"
import { morphdomHold } from "web-ui/morphdom/hold"
import { morphdomPreserveAttributes } from "web-ui/morphdom/preserve-attributes"
import { advanceOrder, isSynchronized, resetOptions } from "web-ui/tom-select/reset-options"

export function TurboMorphSyncPlugin() {
  const tomSelect = this
  let wrapperHold = null
  let inputHold = null

  tomSelect.hook("before", "setup", () => {
    tomSelect.input.addEventListener("morphdom:updated", synchronizeTomSelect)

    morphdomPreserveAttributes(tomSelect.input, ["class", "tabindex"])
    wrapperHold = morphdomHold(tomSelect.wrapper)
  })

  tomSelect.hook("after", "setup", () => {
    advanceOrder(tomSelect)
  })

  tomSelect.on("focus", () => {
    debug("Focus")
    inputHold ??= morphdomHold(tomSelect.input)
  })

  tomSelect.on("blur", () => {
    if (tomSelect.isFocused) {
      return
    }

    debug("Blur")
    releaseInput()
  })

  // The input remains in the document after Tom Select is destroyed. A hold
  // left on it would keep it from being morphed for the rest of its life.
  // - Shaun, Wed Oct 7 2026
  tomSelect.on("destroy", () => {
    debug("Destroy")
    releaseInput()

    if (wrapperHold) {
      wrapperHold.release()
      wrapperHold = null
    }

    tomSelect.input.removeEventListener("morphdom:updated", synchronizeTomSelect)
  })

  function releaseInput() {
    if (inputHold) {
      inputHold.release()
      inputHold = null
    }
  }

  function synchronizeTomSelect(event) {
    const element = event.target

    if (element.disabled && !tomSelect.isDisabled) {
      tomSelect.disable()
    } else if (!element.disabled && tomSelect.isDisabled) {
      tomSelect.enable()
    }

    if (isSynchronized(element, tomSelect)) {
      return
    }

    debug("Synchronizing", { disabled: element.disabled, value: element.value, children: debugChildren(element) })

    resetOptions(element, tomSelect)
  }

  function debugChildren(element) {
    return Array.from(element.children).map((child) => {
      if (child.tagName === "OPTGROUP") {
        return {
          tagName: child.tagName,
          label: child.label,
          children: debugChildren(child)
        }
      } else {
        return {
          tagName: child.tagName,
          value: child.value,
          text: child.text,
          selected: child.selected
        }
      }
    })
  }

  function debug(message, data={}) {
    Object.assign(data, {
      id: tomSelect.input.id
    })

    Log.debug("Tom Select Morphdom Plugin - " + message, data)
  }
}
